import { Navigate, useParams } from 'react-router-dom';

/** Redirects legacy `/tutorials/:tutorialId` URLs to `/tutorials-demo/:tutorialId`. */
const RedirectLegacyTutorial: React.FC = () => {
  const { tutorialId } = useParams<{ tutorialId: string }>();
  return <Navigate to={`/tutorials-demo/${tutorialId}`} replace />;
};

export default RedirectLegacyTutorial;
